module.exports = __webpack_public_path__ + "static/media/oliveflounder.e14ec0f0.png";